import React, { Component } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Button, Dropdown, Table, Icon, Checkbox, Dimmer, Loader, Message } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { fetchContacts, deattachContact } from '~/contact/actions'
import moment from 'moment'
import ContactAdd from '~/contact/views/add'
import ContactEdit from '~/contact/views/edit'
import ContactSearch from '~/contact/views/search'

class OrderContacts extends Component {
  componentDidMount = () => {
    let { fetchContacts, order } = this.props
    fetchContacts({
      order_id: order.get('id'),
    })
  }

  render() {
    let {
      contacts,
      contactsLoading,
      contactsError,
      addContact,
      editContact,
      order,
      adding,
      editing,
      organization_id,
      deattachContact,
    } = this.props
    let order_id = order.get('id')

    contacts = contacts.filter(c => {
      let orders = c.get('orders', List())
      return orders.find(o => o.get('id') === order_id) ? true : false
    })

    let editingContact = editing ? contacts.find(t => t.get('id') === editing) : false

    return (
      <div className="order-contacts">
        <Table selectable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell content="Nimi" />
              <Table.HeaderCell content="Sähköposti" />
              <Table.HeaderCell content="Puhelinnumero" />
              <Table.HeaderCell content="Kieli" />
              <Table.HeaderCell content="" />
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {contactsLoading ? (
              <Table.Row>
                <Table.Cell colSpan="4" className="table-empty-text">
                  Ladataan yhteyshenkilöitä...
                </Table.Cell>
              </Table.Row>
            ) : contacts.size ? (
              contacts.map(contact => {
                let id = contact.get('id')

                return (
                  <Table.Row key={id}>
                    <Table.Cell>
                      <button className="button-plain" onClick={e => e.preventDefault() & editContact(id)}>
                        {contact.get('name')}
                      </button>
                    </Table.Cell>
                    <Table.Cell>{contact.get('email')}</Table.Cell>
                    <Table.Cell>{contact.getIn(['data', 'phone'])}</Table.Cell>
                    <Table.Cell>{contact.get('lang')}</Table.Cell>
                    <Table.Cell>
                      <a
                        href="#"
                        className="button-plain"
                        onClick={e => e.preventDefault() & deattachContact(order_id, id)}>
                        poista
                      </a>
                    </Table.Cell>
                  </Table.Row>
                )
              })
            ) : (
              <Table.Row>
                <Table.Cell colSpan="4" className="table-empty-text">
                  Yhteyshenkilöitä ei ole asetettu.
                </Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan="6" textAlign="left">
                <div className="order-contact-add-wrapper">
                  <ContactSearch
                    order={order}
                    order_id={order.get('id')}
                    organization_id={organization_id}
                    contacts={contacts}
                  />
                  <div className="order-contact-add-button">
                    <button className="button-plain" onClick={e => e.preventDefault() & addContact()}>
                      + Luo yhteyshenkilö
                    </button>
                  </div>
                </div>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
        {editingContact ? (
          <ContactEdit
            order={order}
            contact={editingContact}
            organization_id={organization_id}
            onClose={() => editContact(false)}
          />
        ) : adding ? (
          <ContactAdd order={order} organization_id={organization_id} onClose={() => addContact(false)} />
        ) : null}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    contacts: state.contacts || List(),
    contactsLoading: state.contactsLoading,
    contactsError: state.contactsError,
    adding: state.orderContactCreating,
    editing: state.orderContactEditing,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchContacts: config => dispatch(fetchContacts(config)),
    deattachContact: (order_id, contact_id) => dispatch(deattachContact(contact_id, 'order_id', order_id)),
    addContact: (add = true) => dispatch({ type: 'ORDER_CREATE_CONTACT', add }),
    editContact: id => dispatch({ type: 'ORDER_EDIT_CONTACT', id }),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderContacts)
